import * as Yup from "yup";

export const formValidationSchema = Yup.object().shape({
  tgl_produksi_aset: Yup.string().required("Masukan tanggal"),
});
